<template>
  <div class="panel">
    <div class="panel-header flex justify-between">
      <h2 class="panel-title">Create Postback</h2>
      <button @click="close">
        <v-icon name="io-close" />
      </button>
    </div>
    <div class="panel-body">
      <Banner
        v-if="isAccountLevel"
        banner-class="mb-6 text-sm"
        variant="info"
        icon="bi-info-circle"
        iconClass="mr-2"
      >
        Account Level Postbacks fire conversions on campaigns when no Campaign
        Level Postback is set.
      </Banner>
      <div class="relative flex flex-col space-y-4 rounded-md">
        <div>
          <div class="flex">
            <MultiSelect
              v-model="protocol"
              :options="protocolOptions"
              inputLabel="Protocol"
              label="label"
              trackBy="value"
              :multiple="false"
              class="!w-32"
              inputClass="first-item"
            >
            </MultiSelect>
            <XInput
              inputClass="!rounded-l-none"
              name="vertical-search"
              id="vertical-search"
              placeholder="yourpostback.url/?s1=your_s1_value&revenue=your_revenue_value"
              v-model="postbackUrl"
            />
          </div>
          <div class="text-xs mt-1 text-base-content/50">
            Available parameters are:
            <span class="text-primary"
              >{s1}, {s2}, {s3}, {s4}, {s5}, {revenue} (case insensitive)</span
            >
          </div>
        </div>
      </div>
      <div class="flex mt-4 justify-end">
        <XButton
          @click="save"
          color="primary"
          type="button"
          :is-loading="isSaving"
        >
          Create Postback
        </XButton>
      </div>
    </div>
    <ValidationErrors
      v-if="validationErrors"
      :errors="validationErrors"
      teleport-to="#bottom-sticky"
    />
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { useAuthStore } from "@/stores/auth.js"
import { useMutation } from "@vue/apollo-composable"
import Banner from "@/components/common/Banner.vue"
import CREATE_POSTBACK from "@/graphql/Postback/CreatePostback.gql"
import ValidationErrors from "@/components/common/ValidationErrors.vue"
import { useValidationErrors } from "@/composables/useValidationErrors.js"

const props = defineProps({
  campaignId: {
    type: [String, Number],
  },
})

const { validationErrors, setValidationErrors, clearValidationErrors } =
  useValidationErrors()

const isAccountLevel = computed(() => !props.campaignId)

const isCampaignLevel = computed(() => props.campaignId)

const protocolOptions = [
  {
    label: "https://",
    value: "https",
  },
  {
    label: "http://",
    value: "http",
  },
]



const authStore = useAuthStore()
const postbackUrl = ref("")
const protocol = ref(protocolOptions[0])

const emit = defineEmits(["close"])

const close = () => {
  emit("close")
}

const isSaving = ref(false)
function save() {
  clearValidationErrors()
  isSaving.value = true
  const { mutate: savePostBack } = useMutation(CREATE_POSTBACK, {
    update(cache) {
      cache.evict({ id: `PublisherCampaign:${props.campaignId}` })
      cache.evict({ fieldName: "postbacks" })
      cache.gc()
    },
  })
 
  const input = {
    protocol: protocol?.value?.value ?? "https",
    url: postbackUrl.value ?? undefined,
    conversionType: null,
    campaignId: isCampaignLevel ? props.campaignId : undefined,
  }

  savePostBack({
    input,
  })
    .then(({ data }) => {
      isSaving.value = false
      resetForm()
      close()
    })
    .catch(error => {
      console.error(error)
      setValidationErrors(error)
      isSaving.value = false
    })
}
function resetForm() {
  protocol.value = protocol[0]
  postbackUrl.value = ""
}
</script>
